import {EndConversationModalProps} from './types'
import EndConversationModalView from './EndConversationView'
import React from 'react'
import {endConversation} from '../../../actions/modal'
import {partChannel} from '../../../api/action/partChannel'
import {updateChannel} from 'api/action/updateChannel'
import {useAppDispatch} from '../../../hooks'

const EndConversationModal = (props: EndConversationModalProps): React.ReactElement => {
    const {channelId} = props

    const dispatch = useAppDispatch()

    const closeModal = () => {
        dispatch(endConversation({show: false}))
    }

    const onSkip = () => {
        closeModal()
    }

    const onClose = () => {
        // close conversation
        dispatch(partChannel({channel_id: channelId}))
        closeModal()
    }

    const onEnd = () => {
        // end conversation
        dispatch(updateChannel({
            channel_attrs: {closed: true},
            channel_id: channelId,
        }))
        closeModal()
    }

    return (
        <EndConversationModalView
            onCancel={onSkip}
            onClose={onClose}
            onEnd={onEnd}
        />
    )
}
export default EndConversationModal
